import { Helpers } from '../../helpers';
import { IDataType } from '../../interfaces/idata-type';
import { PrioritizationCategory } from '../prioritization-category';

export class DataTypeBase {
  DataTypeId: number;
  Description: string;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  PrioritizationCategories_DataType?: Array<PrioritizationCategory> | null;

  constructor(item?: IDataType) {
    if (item) {

      this.DataTypeId = item.DataTypeId;
      this.Description = item.Description;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.PrioritizationCategories_DataType = Helpers.createClassArray(PrioritizationCategory, item.PrioritizationCategories_DataType);
    }
  }
}